import { ComponentPropsWithoutRef, PropsWithChildren, useState } from "react";
import * as styles from "./CardResearch.css";
import { Heading } from "~/components/elements/Heading";
import { ButtonLink } from "~/components/elements/ButtonLink";
import { Image } from "~/components/elements/Image";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { Paragraph } from "~/components/elements/Paragraph";
import { getPageSlug, truncate } from "~/styles/functions";
import { Tag } from "~/components/elements/Tag";
import { DocumentResearchPaper } from "~/sanity/types-mapped";

export type CardResearchProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & { card: DocumentResearchPaper };

export const CardResearch = ({ card, ...props }: CardResearchProps) => {
  const {
    title,
    text,
    image,
    region,
    year,
    publisher,
    authors,
    document,
    url,
    researchPaperExternalLink,
  } = card;

  const [isExpanded, setIsExpanded] = useState(
    text && text?.length >= 200 ? false : true,
  );
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        {title && (
          <Heading as="h3" size="h3" className={styles.title} uppercase bold>
            {truncate(title, 60)}
          </Heading>
        )}
        <div className={styles.contentRight}>
          {publisher && (
            <div className={styles.item({ direction: "row" })}>
              <Paragraph bold size="xs" className={styles.rowLabel}>
                Publisher:
              </Paragraph>
              <Paragraph size="sm">{publisher}</Paragraph>
            </div>
          )}
          {authors && (
            <div className={styles.item({ direction: "row" })}>
              <Paragraph bold size="xs" className={styles.rowLabel}>
                Authors:
              </Paragraph>
              <Paragraph size="sm">{authors}</Paragraph>
            </div>
          )}
          {text && (
            <div className={styles.item({ direction: "column" })}>
              <Paragraph bold size="xs" className={styles.rowLabel}>
                Overview:
              </Paragraph>

              <Paragraph
                size="xs"
                className={styles.overview({ isMobile: true })}
              >
                {isExpanded ? text : truncate(text, 200)}
              </Paragraph>
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className={styles.expand}
              >
                <Paragraph size="xs">
                  {!isExpanded ? "Show more" : "Show less"}
                </Paragraph>
              </button>

              <Paragraph
                size="sm"
                className={styles.overview({ isMobile: false })}
              >
                {text}
              </Paragraph>
            </div>
          )}

          {researchPaperExternalLink
            ? // Use URL
              url && (
                <div className={styles.button}>
                  <ButtonLink
                    isPrimary={false}
                    size="sm"
                    theme="colour"
                    icons={{ iconPrimary: <ArrowOutward /> }}
                    link={{
                      _type: "link",
                      newTab: true,
                      slug: url,
                    }}
                  >
                    View Research
                  </ButtonLink>
                </div>
              )
            : //Use Document
              document &&
              document.asset?.url && (
                <div className={styles.button}>
                  <ButtonLink
                    isPrimary={false}
                    size="sm"
                    theme="colour"
                    icons={{ iconPrimary: <ArrowOutward /> }}
                    link={{
                      _type: "link",
                      newTab: true,
                      slug: document.asset?.url,
                    }}
                  >
                    Read Research
                  </ButtonLink>
                </div>
              )}
        </div>
      </div>
    </div>
  );
};
